import { render, staticRenderFns } from "./StepNumber.vue?vue&type=template&id=39cd0218&scoped=true&"
import script from "./StepNumber.vue?vue&type=script&lang=ts&"
export * from "./StepNumber.vue?vue&type=script&lang=ts&"
import style0 from "./StepNumber.vue?vue&type=style&index=0&id=39cd0218&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd0218",
  null
  
)

export default component.exports